window.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => { 
    const section = document.querySelector(".klima-anim-section_our-impact");
    const header = section.querySelector("h2");
    const paragraph = section.querySelector(".klima-text");
    const circles = section.querySelectorAll("li");
  
    // split header words into separate spans for staggered animation
    const headerWords = header.innerHTML.split(" ");
    header.innerHTML = headerWords
      .map((word) => {
        return `<span>${word} </span>`;
      })
      .join("");
  
    const headerWordSpans = header.querySelectorAll("span");
  
    let tl = gsap.timeline({
      scrollTrigger: { trigger: section, start: "top 20%", end: "bottom 40%" },
    });
    tl.fromTo(
      headerWordSpans,
      { clipPath: "inset(100% 0% 0% 0%)" },
      {
        duration: 0.6,
        clipPath: "inset(0% 0% 0% 0%)",
        ease: "power3.out",
        stagger: 0.05,
      }
    );
    tl.fromTo(
      paragraph,
      { y: 100, opacity: 0 },
      {
        duration: 0.5,
        opacity: 1,
        y: 0,
        ease: "power3.out",
        stagger: 0.2,
      },
      "<0.2"
    );
    tl.fromTo(
      circles,
      {
        opacity: 0,
        y: 50,
      },
      {
        opacity: 1,
        y: 0,
        duration: 0.6,
        stagger: 0.1,
        ease: "power3.out",
      },
      "<0.1"
    );
  }, 500)
});
